import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const PrivacyPolicyPage = () => (
  <LegalPageLayout title="Privacy Policy">
    <p className="text-white/60 text-sm">Last updated: {new Date().toLocaleDateString('en-US')}</p>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">1. Information We Collect</h2>
      <p>
        Dial-Grid ("we," "our," or "us") collects information you provide when you register, use our services, or communicate with us. This may include your name, email address, company name, phone number, business address, and payment information. We also collect data about how you use our platform, including inventory, clients, sales, and accounting records.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">2. How We Use Your Information</h2>
      <p>
        We use your information to provide, maintain, and improve our services; to process transactions; to send you service-related communications; to respond to your requests; and to comply with legal obligations. We do not sell your personal information to third parties.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">3. Data Security</h2>
      <p>
        We implement industry-standard security measures to protect your data, including encryption in transit and at rest, access controls, and regular security assessments. You are responsible for maintaining the confidentiality of your account credentials.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">4. Data Sharing</h2>
      <p>
        We may share your information with service providers who assist in operating our platform (e.g., hosting, payment processing, email delivery), subject to confidentiality agreements. We may also disclose information when required by law or to protect our rights and safety.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">5. Your Rights</h2>
      <p>
        Depending on your jurisdiction, you may have the right to access, correct, delete, or export your personal data. You can update your profile in the app or contact us at the email below. You may also opt out of marketing communications at any time.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">6. Contact Us</h2>
      <p>
        For privacy-related questions or requests, contact us at privacy@dial-grid.com.
      </p>
    </section>
  </LegalPageLayout>
);

export default PrivacyPolicyPage;
